import { blockAdapterBase } from 'volto-ministerio-publico-federal/helpers/BlockAdapter/BlockAdapter';
import type { SubHomeCarrosselItem } from './helpers';

interface PageBrain {
  Title?: string;
  [key: string]: unknown;
}

/**
 * Ao escolher o conteúdo no campo Conteúdo, herda o título como legenda.
 *
 * Só preenche legenda vazia — mesma política de `Blocks/OndeAtua/adapter.ts`:
 * depois que o editor escreveu algo, trocar o conteúdo não apaga o trabalho
 * manual; para o preenchimento voltar a rodar, basta limpar o campo.
 *
 * A imagem não entra aqui: é herdada em tempo de render por
 * `getSubHomeCarrosselImageProps`, porque congelar as URLs de escala (que
 * carregam o hash do binário) quebraria o card se a foto do conteúdo mudasse.
 */
export const buildSubHomeCarrosselFields = (
  page: PageBrain,
  item: SubHomeCarrosselItem = {},
): Partial<SubHomeCarrosselItem> =>
  !item.title && page.Title ? { title: page.Title } : {};

export const SubHomeCarrosselBlockDataAdapter = ({
  block,
  data,
  id,
  onChangeBlock,
  value,
}: {
  block: string;
  data: Record<string, unknown>;
  id: string;
  onChangeBlock: (block: string, data: unknown) => void;
  value: unknown;
}) => {
  blockAdapterBase(
    block,
    data,
    id,
    onChangeBlock,
    value,
    'items',
    buildSubHomeCarrosselFields,
  );
};

export default SubHomeCarrosselBlockDataAdapter;
